import {
  THEME_COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  LINE_HEIGHT,
  TRANSITIONS,
} from "../util/themes";

const BASE_STYLES = {
  fontFamily: FONT_FAMILY.primary,
  borderRadius: 0,
  textTransform: 'uppercase' as const,
  transition: TRANSITIONS.color,
  position: 'relative' as const,
  overflow: 'hidden' as const,
  zIndex: 1,
};

export const BUTTON_STYLES = {
  base: BASE_STYLES,

  primary: {
    ...BASE_STYLES,
    backgroundColor: 'transparent',
    color: THEME_COLORS.secondary,
    fontWeight: FONT_WEIGHT.bold,
    fontSize: FONT_SIZE.base,
    px: 4,
    py: 1.5,
    height: '40px',
    lineHeight: LINE_HEIGHT.normal, 
    border: 'none',
    borderRadius: 0,
    borderBottom: `1px solid ${THEME_COLORS.secondary}`,
    width: '100%',
    textTransform: 'uppercase',
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '0%',
      backgroundColor: THEME_COLORS.secondary,
      transition: 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      zIndex: -1,
    },
    '&:hover': {
      color: 'white',
      backgroundColor: 'transparent',
      '&:before': {
        height: '100%',
      }
    },
  },

  secondary: {
    ...BASE_STYLES,
    color: THEME_COLORS.greyMedium,
    fontWeight: FONT_WEIGHT.light,
    fontSize: FONT_SIZE.sm,
    padding: '10px 15px',
    height: '20px',
    border: 'none',
    borderBottom: `1px solid ${THEME_COLORS.greyLight}`,
    textTransform: 'none' as const,
    transition: TRANSITIONS.color,
    minWidth: 'auto',
    '&:hover': {
      color: THEME_COLORS.secondary,
      backgroundColor: 'transparent',
      borderBottom: `1px solid ${THEME_COLORS.greyLight}`,
    }
  },

  icon: {
    borderRadius: 0,
    backgroundColor: "transparent",
    height: '40px',
    width: '40px',
    color: THEME_COLORS.secondary,
    border: 'none',
    '&:hover': {
      backgroundColor: "transparent",
      color: "#5a6c6d",
    }
  },

  disabled: {
    cursor: 'not-allowed',
    '&:hover': {
      color: '#dddddd',
      backgroundColor: 'transparent',
      cursor: 'not-allowed',
    }
  },

  grey: {
      borderRadius: 0,
      borderColor: THEME_COLORS.greyLight,
      backgroundColor: THEME_COLORS.greyLight,
      color: THEME_COLORS.primary,
      textTransform: 'none' as const,
      '&:hover': {
        borderColor: THEME_COLORS.greyLight,
        backgroundColor: THEME_COLORS.greyLight,
        color: THEME_COLORS.secondary,
      }
    },
    text: {
      color: THEME_COLORS.greyMedium,
      fontWeight: FONT_WEIGHT.light,
      fontSize: FONT_SIZE.sm,
      fontFamily: FONT_FAMILY.primary,
      padding: '10px 15px',
      height: '20px',
      borderRadius: 0,
      border: 'none',
      textTransform: 'none' as const,
      transition: TRANSITIONS.color,
      minWidth: 'auto',
      '&:hover': {
        color: THEME_COLORS.secondary,
        backgroundColor: 'transparent',
      }
    },
    borderedText: {
      color: THEME_COLORS.greyMedium,
      fontWeight: FONT_WEIGHT.light,
      fontSize: FONT_SIZE.sm,
      fontFamily: FONT_FAMILY.primary,
      padding: '10px 15px',
      height: '20px',
      borderRadius: 0,
      border: 'none',
      borderBottom: `1px solid ${THEME_COLORS.greyLight}`,
      textTransform: 'none' as const,
      transition: TRANSITIONS.color,
      minWidth: 'auto',
      '&:hover': {
        color: THEME_COLORS.secondary,
        backgroundColor: 'transparent',
        borderBottom: `1px solid ${THEME_COLORS.greyLight}`,
      }
    },
    invertedPrimary: {
        ...BASE_STYLES,
        backgroundColor: THEME_COLORS.secondary,
        color: 'white',
        fontWeight: FONT_WEIGHT.bold,
        fontSize: FONT_SIZE.base,
        px: 4,
        py: 1.5,
        height: '40px',
        lineHeight: LINE_HEIGHT.normal,
        border: 'none',
        borderRadius: 0,
        overflow: 'hidden',
        position: 'relative',

        '&:before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: '0%',
            backgroundColor: 'white',
            transition: 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            zIndex: -1,
        },

        '&:hover': {
            color: THEME_COLORS.secondary,
            '&:before': {
                height: '100%',
            }
        },
    },
    outlinedPrimary: {
        ...BASE_STYLES,
        backgroundColor: "transparent",
        color: THEME_COLORS.secondary,
        fontWeight: FONT_WEIGHT.bold,
        fontSize: FONT_SIZE.base,
        px: 4,
        py: 1.5,
        height: "40px",
        lineHeight: LINE_HEIGHT.normal,
        borderRadius: 0,
        border: `1px solid ${THEME_COLORS.secondary}`,
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            color: THEME_COLORS.secondary,
            border: `1px solid ${THEME_COLORS.secondary}`,
            boxShadow: "none",
        },
    } as const,

    compact: {
        fontSize: FONT_SIZE.sm,
        px: 2,
        py: 0.5,
        height: '32px',
    }

} as const;














